<template>
    <div class="trial-balance-account-cell flex items-baseline gap-2">
        <div class="text-primary text-lg w-14 min-w-14">
            <account-link :account-no="account.accountNo">
                {{ account.accountNo }}
            </account-link>
        </div>
        <div>
            {{ accountName }}
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, provide} from 'vue'
import {LedgerAccount} from '@/types/reports/LedgerAccount'
import {findAccountByNo} from '@/bookkeeping-account/bookkeepingAccount.service'
import AccountLink from '@/bookkeeping-account/AccountLink.vue'

const props = defineProps({
    params: {
        type: Object as () => { 
            data: LedgerAccount,
            context: {
                panelId: Number,
                panelPathSegment: String,
            }
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const account = computed<LedgerAccount & {rowIsPinned?: boolean}>(() => {
    return props.params.data
})

const accountName = computed(() => {
    return findAccountByNo(account.value.accountNo)?.name
})

</script>

<style>

</style>